import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { notification } from 'antd';
import { AppButton } from 'shared/UI/UIKit/Button';
import { AppFlex } from 'shared/UI/UIKit/Flex';
import { useAuth } from 'shared/services/auth';
import { ERROR_CODE_SEARCH_PARAM } from 'services/navigation';
import styles from './Authorization.module.scss';

export const Authorization = () => {
  const { login } = useAuth();
  const searchParams = useSearchParams();

  useEffect(() => {
    const error = searchParams[0].get(ERROR_CODE_SEARCH_PARAM);

    if (error && error === 'access_denied') {
      notification.error({
        message: 'Доступ к личному кабинету запрещен',
        description: 'Личный кабинет недоступен. Свяжитесь с администратором.',
        duration: 0,
      });
      window.history.replaceState({}, document.title, window.location.pathname);
    }
  }, [searchParams]);

  return (
    <AppFlex
      className={styles.container}
      direction="row"
      unit="40"
      alignItems="center"
      justifyContent="center"
    >
      <AppFlex direction="row">
        <AppFlex unit="10">
          <AppButton onClick={login}>Войти</AppButton>
        </AppFlex>
      </AppFlex>
    </AppFlex>
  );
};
